import { Spinner } from '@heroui/react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 48px;
  justify-content: center;
  align-items: center;
`;

export const LoadingMessage = () => (
  <Container>
    <Spinner color='white' size='sm' />
  </Container>
);
